import { Controller } from '@hotwired/stimulus'
import { useEventListener } from '~/controllers/concerns/use_event_listener'

export default class extends Controller {
  connect() {
    useEventListener(this, {
      element: window,
      event: 'turbo:before-stream-render',
      listener: 'beforeTurboStreamRender'
    })
  }

  /**
   * Check if current browser window/tab is visible before display a flash message from Turbo Stream.
   * This ensures a user will not see the same message multiple time in different windows/tabs.
   * @see https://turbo.hotwired.dev/handbook/streams#custom-actions
   */
  beforeTurboStreamRender(event) {
    const defaultRender = event.detail.render

    event.detail.render = streamElement => {
      if (this.#willUpdateElement(streamElement) && document.hidden) {
        return false
      }
      return defaultRender(streamElement)
    }
  }

  #willUpdateElement(streamElement) {
    return streamElement.target === this.element.id
  }
}
